import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import {
  useGoalsServiceGoalsControllerAcceptRecommendation,
  useGoalsServiceGoalsControllerGetAllKey,
  useGoalsServiceGoalsControllerGetRecommendationsKey,
  useGoalsServiceGoalsControllerRejectRecommendation,
} from '@/__generated__/queries'

export const useRejectRecommendation = (id: number) => {
  const queryClient = useQueryClient()

  const rejectMutation = useGoalsServiceGoalsControllerRejectRecommendation({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Recommendation has been successfully rejected',
        title: 'Recommendation rejected',
      })

      queryClient.invalidateQueries({
        queryKey: [useGoalsServiceGoalsControllerGetRecommendationsKey],
      })
    },
  })

  return {
    rejectRecommendation: () => rejectMutation.mutate({ recommendationId: id }),
  }
}

export const useAcceptRecommendation = (id: number) => {
  const queryClient = useQueryClient()

  const acceptMutation = useGoalsServiceGoalsControllerAcceptRecommendation({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Recommendation has been successfully accepted',
        title: 'Recommendation accepted',
      })

      const keys = [
        useGoalsServiceGoalsControllerGetRecommendationsKey,
        useGoalsServiceGoalsControllerGetAllKey,
      ]

      keys.forEach(key =>
        queryClient.invalidateQueries({
          queryKey: [key],
        }),
      )
    },
  })

  return {
    acceptRecommendation: () => acceptMutation.mutate({ recommendationId: id }),
  }
}
